/* eslint-disable no-unused-vars */
/** 迁移自 kbWelfareCenter/src/kb_welfare/rootStore.js */

import Aegis from '@tencent/aegis-web-sdk';
import React from 'react';

import { detector } from './lib/util/Detect.js';
import { Cookies } from 'react-cookie';
import { SignInCoinDialog, ActionFalseDialog, OpenRedpackDialog, SignInVipDialog, WelfareGuideDialog } from './components';
import { setDailyTask, setSignTask, setIsNewUser, setHasInviteCard, setMyIntegral, mapAppMainAccount, setIsLogin, setCredit, setPreProcess, setDialogs, setShowTaotieSwing, setShowTaotie, setShowPropertyTransAnim, setWithdrawMiniNum } from './actions';
import { post, $http, loginWithInfo, showLoginPanel, refreshToken, wxAuth } from './lib/kbApp/kbJsBridgePromise';
import { getAppMainAccount } from './lib/services/kbAppService';
import { getHost, ACCOUNT, excitedVideoAdApiJsUrl, nfaMotivationJsUrl, aegisOpts, hostv2, ACCOUNT_TYPE, ugpageHost, createSessionHost, kdILiveHost, tencentLiveHost, API_RESP_CODE, GET_COUPON_AUTH_RROR, WELFARE_TASK_BUSINESS_ID } from './const';

import signInError from './const/signInError';
import sendBoss from './lib/base/sendBoss';
import { query } from './lib/util/common';
import { showTip } from './lib/util/domUtil.js';
import Log from './lib/util/log';
import { loadScript } from './lib/util/utils';
import store from './store';

const cookies = new Cookies();

const { SUCCESS } = API_RESP_CODE;
const { USuccess, UError, UWxAuthError, UWXAuthCancel } = GET_COUPON_AUTH_RROR;
const {
  WELFARE_NOVEL_SIGN_IN_28DAYS,
  WELFARE_NOVEL_VIDEO,
  BUSINESS_ID_FOR_REMIND,
  BUSINESS_ID_FOR_INVITE,
  KUAIBAO_SIGN_IN,     // 快报,签到
  KUAIBAO_SIGN_IN_ACTIVE, // 快报,签到活动
  KUAIBAO_INVITE,      // 快报,邀请
  TREASURE_BOX_TASK /** 宝箱任务 */,
  SIGN_IN_AD_VIDEO /** 签到完成弹窗激励视频任务 */,
  REGULAR_TASK_LIST_AD_VIDEO /** 日常任务完成弹窗激励视频任务 */,
  MAIN_READING_TASK_AD_VIDEO /** 极速版主时长任务领钱弹窗激励视频任务 */,
  TREASURE_BOX_TASK_AD_VIDEO /** 宝箱激励视频任务 */,
  PUSH_SHARE_TASK,
} = WELFARE_TASK_BUSINESS_ID;

export function getWelfareCenterParams() {
  const { kbApp } = store.getState();
  const { omgid = '', devid = '', imsi = '', guid = '', qua = '' } = kbApp;
  const { userId, token = '', skey = '', qbid = '', platform = '', appid = '', type = 1 } = kbApp.userInfo || {};

  const params = {
    applicationId: detector.app.kuaibao ? 1 : 0, // 1:快报, 0:qb
    welfareVersion: 2, // 区分福利中心新老版本
    userId,
    qbid: detector.app.kuaibao ? userId : qbid,  // 快报取userId，qb取qbid
    uin: userId,
    type,
    guid: detector.app.kuaibao ? omgid : guid,  // 快报取omgid，qb取guid
    token,
    skey,
    qua,
    platform,
    appid,
  };

  if (detector.app.kuaibao) {
    params.devType = detector.os.android ? 0 : (detector.os.iphone ? 1 : 0); // devType: 0:android;1:ios
    params.devId = detector.os.android ? (`${devid}_${imsi || ''}`) : (detector.os.iphone ? devid : ''); // android：devid加下划线
  }

  cookies.set(
    'welfareUserInfo',
    params,
    {
      path: '/',
      domain: 'qq.com',
    },
  );
  return params;
}

// 获取签到任务
export const getSignTaskAction = () => {
  const param = Object.assign(getWelfareCenterParams(), {
    signType: 2,
  });

  return post(`${getHost()}/newtickets/api/getSignTask`, param).then((res) => {
    if (res.code === 0) {
      const signTaskData = res.data.signTask || [];
      signTaskData.hasSigned = res.data.hasSigned;

      store.dispatch(setSignTask(signTaskData));
    }
  });
};

// 签到
let signInLock = false;
export const signInAction = (type) => {
  if (signInLock) {
    return;
  }

  let signType = 'defaultsign';
  if (type === 'vip') {
    signType = 'vipsign';
  } else if (type === 'cash') {
    signType = 'cashsign';
  }

  const { dialogs } = store.getState();
  const param = Object.assign(getWelfareCenterParams(), {
    refer: query('refer') || '',
  });
  signInLock = true;
  // sendBoss('element_click', {
  //   element_type: `${signType}`,
  //   element_name: `${signType}_popup_login_confirm`,
  // });
  post(`${getHost()}/newtickets/api/signIn`, param).then((res) => {
    signInLock = false;

    dialogs.pop();  // 清空弹窗（如果有的话）
    if (res.code === 0) {
      const { data } = res;
      const { signTask } = data;

      const {
        stepWelfare = [],
        completed = 0,
        isContinueTask,
        continueTaskDays = 0,
      } = signTask;
      const taskDays = isContinueTask ? continueTaskDays : completed;

      signTask.hasSigned = true;
      store.dispatch(setSignTask(signTask));

      const welfare = stepWelfare[taskDays > 0 ? taskDays - 1 : 0] || {};
      const welfareInfo = welfare.welfareInfo || {};
      const len = dialogs.length;

      if (type === 'vip') {   // vip卡券奖励
        store.dispatch(setDialogs(dialogs.concat([
          <SignInVipDialog
            key={len}
            welfareInfo={welfareInfo}>
          </SignInVipDialog>,
        ])));
      } else if (type === 'cash') {  // 现金奖励
        const value = welfareInfo.value / 100 || 0;
        store.dispatch(setDialogs(dialogs.concat([
          <OpenRedpackDialog key={len} num={value.toFixed(2)} desc="签到成功，今日现金已领取" from="signin"></OpenRedpackDialog>,
        ])));
      } else {
        store.dispatch(setDialogs(dialogs.concat([
          <SignInCoinDialog
            key={len}
            welfare={welfare}
            value={welfareInfo.value || 0}
            welfareType={welfareInfo.welfareType}>
          </SignInCoinDialog>,
        ])));
      }
    }
  })
    .catch((res) => {
      const { code } = res;
      const msg = signInError[code] || '请求异常，请稍后再试';
      const len = dialogs.length;
      store.dispatch(setDialogs(dialogs.concat([
        <ActionFalseDialog key={len} title="很抱歉，签到失败" subTitle={msg}></ActionFalseDialog>,
      ])));
    });
};

// 初始化广告js
export const initAd = async (taskId) => {
  // 加载广告js
  if (detector.app.kuaibao) {
    loadScript(excitedVideoAdApiJsUrl).then(() => {
      window.QBExcitedVideoAdApi && window.QBExcitedVideoAdApi.onStateChange((state, res, adRes = {}, amsData = {}) => {
        if (state === 'onADClose') {
          // 刷新资产和任务列表
          getMyIntegralAction();
          getTaskDataAction(false);
        } else if (state === 'onError') {
          showTip('视频加载失败，请重试', 3000, { style: 'width: 2rem;' });
          // 上报atta
          sendBoss('loadAdFail', {
            extra_info: {
              amsData,
            },
          });
        }
      });
      // 加载广告，进度页面时预载
      const env = process.env.isTest || process.env.NODE_ENV === 'development' ? 'test' : 'production';
      window.QBExcitedVideoAdApi && window.QBExcitedVideoAdApi.loadAD(taskId, env);
    });
  } else if (detector.app.qb) {
    await loadScript(nfaMotivationJsUrl);
  }
};

/**
 * 获取任务列表
 * @param {boolean} loadAd 是否初始化广告
 */
export const getTaskDataAction = async (loadAd = true, from = '') => {
  if (from === 'sendTask') {
    sendBoss('sendTaskRedPackResponceAfter', {
      extra_info: { time: new Date().getTime() },
    });
  }
  const param = Object.assign(getWelfareCenterParams(), {
    refer: query('refer') || '',
  });

  return post(`${getHost()}/newtickets/api/getTasks`, param).then(async (res) => {
    if (res.code === 0) {
      store.dispatch(setIsNewUser(res.data.isNewUser || false));
      store.dispatch(setWithdrawMiniNum(res.data.withdrawMinimun));

      const dailyTasks = (res.data && res.data.dailyTasks) || [];
      const tasks = [];
      const { kbApp } = store.getState();
      const { userInfo = {} } = kbApp || {};

      dailyTasks.forEach((task) => {
        // 临时加下 为了屏蔽1002 qb广告任务在正式环境不展示
        // 签到和邀请拎出来，不在日常任务里
        // 屏蔽小说28天签到
        // 屏蔽小说激励视频任务305
        // 屏蔽小说组队活动提醒任务308
        // 屏蔽小说邀请好友组队任务309
        // 屏蔽宝箱任务3203
        // 屏蔽签到完成弹窗激励视频任务1003
        // 屏蔽日常任务完成弹窗激励视频任务1004
        // 屏蔽极速版主时长任务领钱弹窗激励视频任务1005
        // 宝箱激励视频任务1006
        if ([0, 1, 2].includes(task.taskBelong) && ![
          KUAIBAO_SIGN_IN,
          KUAIBAO_SIGN_IN_ACTIVE,
          KUAIBAO_INVITE,
          WELFARE_NOVEL_SIGN_IN_28DAYS,
          WELFARE_NOVEL_VIDEO,
          BUSINESS_ID_FOR_REMIND,
          BUSINESS_ID_FOR_INVITE,
          TREASURE_BOX_TASK /** 宝箱任务 */,
          SIGN_IN_AD_VIDEO /** 签到完成弹窗激励视频任务 */,
          REGULAR_TASK_LIST_AD_VIDEO /** 日常任务完成弹窗激励视频任务 */,
          MAIN_READING_TASK_AD_VIDEO /** 极速版主时长任务领钱弹窗激励视频任务 */,
          TREASURE_BOX_TASK_AD_VIDEO, /** 宝箱激励视频任务 */
        ].includes(task.businessId)) {
          // 登录渠道进来的展示登录任务
          if (task.businessId === 10001) {
            if (Number(query('from_where')) === 10888) {
              tasks.push(task);
            }
          } else if (task.businessId === PUSH_SHARE_TASK) {
            // 特定渠道来的展示push任务
            if (Number(query('from_where')) === 500) {
              tasks.push(task);
            }
          } else {
            tasks.push(task);
          }
        }

        if (task.businessId === 2900) {  // 存在邀请模块
          store.dispatch(setHasInviteCard(true));
        }
      });

      // 判断是否有广告任务 是就加载广告js
      if (loadAd) {
        const adTasks = tasks.filter(task => task.businessId === 3100 || task.businessId === 1002);
        adTasks.length > 0 && initAd(adTasks[0].taskId);
      }

      console.log('dailyTasks businessIds', dailyTasks.map(task => task.businessId));
      const loginGuidTask = dailyTasks.find(task => task.businessId === 10001);
      console.log('loginGuidTask', loginGuidTask);

      // 登录引导任务登录情况下未完成需要出领取弹窗
      if (Number(query('from_where')) === 10888 && param.qbid && loginGuidTask && loginGuidTask.completed < loginGuidTask.totalStep) {
        try {
          // 清空弹窗
          store.dispatch(setDialogs([]));

          // 出领取弹窗
          sendBoss('element_exposure', {
	        page_id: 'welfareIndex',
	        element_type: 'login_mission',
	        element_name: 'login_popup_success',
          });

          store.dispatch(setDialogs([
            <WelfareGuideDialog key={ 1 } confirmCb={ async () => {
              // 出领取弹窗
              sendBoss('element_click', {
                page_id: 'welfareIndex',
                element_type: 'login_mission',
                element_name: 'login_popup_success',
              });

              const reportRet = await $http.post('/ugwelfare/api/tasks/reportTaskEnvolve', {
                data: Object.assign({}, param, {
                  taskType: loginGuidTask.taskType,
                  omgid: param.guid,
                  openid: param.qbid,
                  businessId: loginGuidTask.businessId,
                  reportBusinessId: loginGuidTask.businessId,
                  taskId: loginGuidTask.taskId,
                  step: 1,
                  type: 0,
                  source: query('task_source') || 'welfarecenter', // 任务领取来源
                }),
              });
              console.log('reportRet', reportRet);

              $http.post('/newtickets/api/sendTaskWelfare', {
                // 上报任务进度
                data: Object.assign(getWelfareCenterParams(), {
                  taskId: loginGuidTask.taskId,
                  businessId: loginGuidTask.businessId,
                }),
              }).then((res) => {
                if (res.code === 0) {
                  let welfareValue = 0;
                  let welfareType = 3;
                  let welfare = {};

                  if (res.data.integral) { // 金币
                    welfareType = 3;
                    welfareValue = res.data.integral;
                  } else if (res.data.coupons && res.data.coupons.length) { // 广告礼券
                    welfareType = 1;
                    welfare = {
                      coupons: res.data.coupons,
                    };
                  } else if (res.data.amount) { // 红包
                    welfareType = 0;
                    welfareValue = res.data.amount;
                  }

                  const { dialogs } = store.getState();
                  const len = dialogs.length;

                  sendBoss('element_exposure', {
                    page_id: 'welfareIndex',
                    element_type: 'login_mission',
                    element_name: 'get_popup_success',
                  });

                  store.dispatch(setDialogs(<SignInCoinDialog key={ len } from="task" welfare={ welfare } value={ welfareValue } welfareType={ welfareType }
                    confirmCb={ () => {
                      sendBoss('element_click', {
                        page_id: 'welfareIndex',
                        element_type: 'login_mission',
                        element_name: 'get_popup_success',
                      });
                    }}></SignInCoinDialog>,));
                  //   getMyIntegralAction();
                  getTaskDataAction(false, 'sendTask');
                }
              })
                .catch(e => console.log(e));
            }}></WelfareGuideDialog>,
          ]));
        } catch (error) {
          console.log(error);
        }
      }

      console.log('tasks', tasks);
      store.dispatch(setDailyTask(tasks));
    }
  })
    .catch(e => console.log(e.message));
};

// 获取账号现金金币信息
let refreshTokenCount = 0;
export const getMyIntegralAction = () => $http.get('/ugwelfare/api/userAccount', {
  params: Object.assign(getWelfareCenterParams(), {
    scene: 'kb_welfare',
    needWithdrawRules: true,
    ts: Date.now(),
  }),
}).then((res) => {
  if (res.code === 0) {
    const asset = res.data || {};
    if (asset.rate < 20000) asset.rate = 20000;
    store.dispatch(setMyIntegral(asset));
    // 上报成功
    sendBoss('getMyIntegral', {
      element_type: res.code,
      extra_info: {
        refreshTokenCount: `count_${refreshTokenCount}`,
      },
    });
  }
})
  .catch((res) => {
    // 上报异常code
    sendBoss('getMyIntegral', {
      element_type: res.code,
      extra_info: {
        refreshTokenCount: `count_${refreshTokenCount}`,
      },
    });
    // 如果登录态过期则刷新token
    if (res.code === 4003) {
      // showTip('登录态过期，请重新登录', 3000, { style: 'width: 2rem;' });
      const { kbApp } = store.getState();
      const { userInfo } = kbApp || {};
      const uin = userInfo.uin || '';
      // 只做一次刷新token操作，如果刷新一次还不行就弹出tips引导重新登录
      if (!uin || refreshTokenCount > 0) {
        showTip('登录态过期，请重新登录', 3000, { style: 'width: 2rem;' });
        // 上报弹出tip的曝光
        sendBoss('getMyIntegral', {
          element_type: res.code,
          element_name: 'tip',
          extra_info: {
            refreshTokenCount: `count_${refreshTokenCount}`,
          },
        });
      } else {
        // 上报refreshToken
        sendBoss('refreshToken', {
          element_type: userInfo.type,
        });
        return refreshToken({ uin }).then((ret) => {
          // 计数 以防进入死循环
          refreshTokenCount += 1;
          // 微信和手机号登录的情况下可以直接刷新token
          // QQ和QQ互联登录情况下无法直接刷新token，执行refreshToken是做自动退出并弹窗引导重新登录
          // 更新store的用户信息
          if ([ACCOUNT_TYPE.PHONE, ACCOUNT_TYPE.WEIXIN].includes(userInfo.type) && ret.uin && ret.token) {
            const newUserInfo = {
              isLogin: true,
              userInfo: Object.assign(userInfo, ret),
            };
            // 上报刷新token回调
            sendBoss('refreshToken', {
              element_type: userInfo.type,
              extra_info: ret,
            });
            // 重新请求资产接口
            return store.dispatch(mapAppMainAccount(newUserInfo)).then(() => getMyIntegralAction());
          }
        });
      }
    }
  });

// 统一登录逻辑
export const loginAction = (loginInfo) => {
  if (detector.app.kuaibao) {
    return loginWithInfo(loginInfo).then(() => {
      // 获取主登录账号及账号信息
      getAppMainAccount().then((res) => {
        store.dispatch(mapAppMainAccount(res));
      })
        .then(() => {
          getSignTaskAction().then(() => {
            store.dispatch(setIsLogin(true)); // 设置全局登录态
          });
          getMyIntegralAction();
          getTaskDataAction();
          getUserCreditAction();
          initAegis();
        });
    });
  }
  showLoginPanel();
};

export const getUserCreditAction = () => {
  // 这个接口只校验快报 所以qb提前return
  if (detector.app.qb) return;

  const param = getWelfareCenterParams();

  return post(`${getHost()}/newtickets/api/getCredit`, param).then((res) => {
    if (res.code === 0) {
      store.dispatch(setCredit(res.data.credit || 0));
    }
  })
    .then(() => {
      addTransAccountDialog();
    });
};

export function doPreProcess(cbk, list) {
  const preProcessList = list || store.getState().preProcess;
  // 暂时不做异步操作
  preProcessList.forEach((process) => {
    process();
  });

  if (preProcessList.length === 0 && cbk) return cbk;
  return () => {};
}

export async function getSmallPrice() {
  try {
    const res = await $http.get(`${hostv2}/ugwelfare/api/smallPrice`, {
      params: getWelfareCenterParams(),
    });
    if (res.code === 0 && res.data) return res.data.smallPrice;
  } catch (error) {
    console.error(error);
    return 30 * 60;
  }
}

// push 切换账号指引弹窗
export function addTransAccountDialog() {
  const { mainAccount } = store.getState().kbApp;
  const { credit } = store.getState();
  let title;
  let subTitle;

  if (mainAccount !== 'other' && ![ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK].includes(credit)) {
    store.dispatch(setPreProcess([]));
    return;
  }
  if (mainAccount === 'other') {
    // 手机登录
    title = '很抱歉，请切换帐号';
    subTitle = '活动仅限QQ或微信登录用户参加';
  } else if (ACCOUNT.STATUS.NOT_MATCH_DEVICE === credit) {
    // 未绑定
    title = '很抱歉，设备已经绑定别的账号';
    subTitle = '需要登录绑定账号才可以参与活动';
  } else if (ACCOUNT.STATUS.TINAYU_BLACK === credit) {
    // 天域高风险
    title = '很抱歉，账号异常';
    subTitle = '可切换其他账号尝试参与活动';
  }

  const { dialogs } = store.getState();
  const len = dialogs.length;
  const { preProcess } = store.getState();
  const process = () => {
    store.dispatch(setDialogs(dialogs.concat([
        <ActionFalseDialog key={len} title={title} subTitle={subTitle} from="transAccount"></ActionFalseDialog>,
    ])));
  };

  if ([ACCOUNT.STATUS.NOT_MATCH_DEVICE, ACCOUNT.STATUS.TINAYU_BLACK].includes(credit)) {
    // 这种情况是进入页面就要弹窗
    doPreProcess(null, [process]);
  }
  store.dispatch(setPreProcess(preProcess.concat(process)));
}

export function setWelfareAnimation() {
  const { isShowTaotieSwing } = store.getState();
  if (isShowTaotieSwing) return;
  store.dispatch(setShowTaotie(true));
  setTimeout(() => {
    store.dispatch(setShowTaotieSwing(true));
    store.dispatch(setShowTaotie(false));
  }, 3700);
}

// 前端增量增加金币或现金
export function setProperty(params) {
  console.log(params, 'params');
  const { value, welfareType } = params;
  const { myIntegral } = store.getState();
  let updateType = '';

  if (welfareType === 0 || welfareType === 4) {
    // 现金
    updateType = 'cash';
  } else if (welfareType === 3 || welfareType === 5) {
    // 金币
    updateType = 'coin';
  }

  // 不是金币或者现金 不用更新资产做动画
  if (updateType !== 'cash' && updateType !== 'coin') return;

  const propertyTransAnim = {};

  const amountDiff = updateType === 'cash' ? value / 100 : 0;
  const integralDiff = updateType === 'coin' ? value : 0;

  switch (updateType) {
    case 'coin':
      propertyTransAnim.integralDiff = integralDiff;
      break;
    case 'cash':
      propertyTransAnim.amountDiff = amountDiff;
      break;
    default:
      break;
  }

  const { integral = 0, amount = 0 } = myIntegral || {};
  const property = {
    ...myIntegral,
    integral: integral + integralDiff,
    amount: amount + amountDiff,
  };

  store.dispatch(setMyIntegral(property));
  store.dispatch(setShowPropertyTransAnim(propertyTransAnim));
}

// 初始化aegis
export function initAegis() {
  const { kbApp } = store.getState();
  const { qbid = '' } = kbApp.userInfo || {};
  const defaultOpts = detector.app.kuaibao ? aegisOpts.kb : aegisOpts.qb;

  const opts = {
    ...defaultOpts,
    uin: qbid,
    reportApiSpeed: true,
    reportAssetSpeed: true,
    offlineLog: true,
    spa: true,
  };

  const aegis = new Aegis(opts);
  window.aegisIns = aegis;
}


export async function getKbAsset(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/getKbAsset`, {
    data: params,
  });
}

export async function withdrawKb(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/kbOfflineWithdraw`, {
    data: params,
  });
}

export async function checkBlackAccount(opts = {}) {
  const params = Object.assign(getWelfareCenterParams(), opts);
  return $http.post(`${hostv2}/ugwelfare/api/userSCheck`, {
    data: params,
  });
}

// 兑换现金
let withdrawLock = false;
export async function autoExchange(myIntegral = {}) {
  if (withdrawLock) return;
  const { integral = 0, amount = 0 } = myIntegral;
  console.log(myIntegral, 'myIntegral');
  if (integral <= 0) return;
  withdrawLock = true;

  $http.get(`${hostv2}/ugwelfare/api/kbOfflineExchange`, {
    params: Object.assign(getWelfareCenterParams(), {
      scene: 'kb_v2',
    }),
  }).then((res) => {
    if (res.code === 0 && res.data) {
      const { exchangeIntegral = 0, getAmount = 0 } = res.data;
      console.log(res.data, 'res.data');
      store.dispatch(setMyIntegral({
        ...myIntegral,
        integral: integral - exchangeIntegral,
        amount: (getAmount + (amount * 100)) / 100,
      }));
    }
  })
    .finally(() => {
      withdrawLock = false;
    });
}

// https://qbact.sparta.html5.qq.com/welfareuser/api/delVeriyIdCard?qbid=154b8153002ed8c5
export async function idOffAction() {
  const param = getWelfareCenterParams();

  return $http.post(`${hostv2}/welfareuser/api/delVeriyIdCard`, {
    data: param,
  });
}

export async function getBindIdcard() {
  const param = getWelfareCenterParams();

  return $http.get(`${hostv2}/welfareuser/api/getBindIdcard`, {
    params: param,
  });
}

/**
 * @desc 获取优惠券奖励流水
 */
export async function getCouponTurnover(tradeNoArr) {
  const ret = {
    code: -1,
    list: [],
  };

  try {
    const welfareUserInfo = getWelfareCenterParams();
    const result = await $http.post(`${ugpageHost}/ugwelfare/api/getTurnover`, {
      data: {
        ...welfareUserInfo,
        applicationId: 0,
        tradeNoArr,
        welfareType: 10,
        page: 1,
      },
    });

    if (result.code === 0) {
      ret.code = 0;
      ret.list = result.data.list;
      return ret;
    }
    return ret;
  } catch (error) {
    Log.getInstance().logErr(`rootStore.getTurnover ${JSON.stringify(error)}`);
    return ret;
  }
}

/**
 * @desc 修改用户奖励流水
 */
export async function updateRecordStatus({ id, tradeNo, tradeType, oldTradeStatus, newTradeStatus, statusType }) {
  const ret = {
    code: -1,
    status: -1,
  };

  try {
    const welfareUserInfo = getWelfareCenterParams();
    const result = await $http.post(`${ugpageHost}/ugwelfare/api/updateRecordStatus`, {
      data: {
        userInfo: {
          ...welfareUserInfo,
          applicationId: 0,
        },
        id,
        tradeNo,
        tradeType,
        oldTradeStatus,
        newTradeStatus,
        statusType,
      },
    });

    if (result.code === 0) {
      ret.code = 0;
      ret.status = result.data.status;
      return ret;
    }
    return ret;
  } catch (error) {
    Log.getInstance().logErr(`rootStore.updateRecordStatus ${JSON.stringify(error)}`);
    return ret;
  }
}

/**
 * 获取浏览器sk、sa
 */
export async function createSession(once = false) {
  try {
    const { session = {}, userInfo = {} } = store.getState().kbApp || {};
    if (session && session.sa && session.sk) {
      return session;
    }

    const welfareUserInfo = getWelfareCenterParams();
    const params = {
      info: {
        ...welfareUserInfo,
      },
      guid: welfareUserInfo.guid,
      qua: welfareUserInfo.qua,
    };

    const resp = await $http.post(`${createSessionHost}/trpc.tkdqb.qblogin.qblogin/CreateSession`, {
      data: params,
    });

    const respStr = JSON.stringify(resp);
    const { err_code: errCode, sk = '', sa = '' } = resp;

    // 成功
    if (errCode === SUCCESS) {
      return {
        sk,
        sa,
      };
    }

    // token过期
    if (errCode === 2001 && !once) {
      // 刷新token
      const refreshRet = await refreshToken({ uin: userInfo.uin });
      let newUserInfo = {};
      if ([ACCOUNT_TYPE.PHONE, ACCOUNT_TYPE.WEIXIN].includes(userInfo.type) && refreshRet.uin && refreshRet.token) {
        newUserInfo = {
          isLogin: true,
          userInfo: Object.assign(userInfo, refreshRet),
        };
      }
      await store.dispatch(mapAppMainAccount(newUserInfo));
      throw new Error(`rootStore.createSession token expired. refresh token. resp: ${respStr}, code: ${errCode}`);
    }

    // 登录态校验失败或token刷新后仍失败
    if (errCode === 2001 && once) {
      throw new Error(`rootStore.createSession refresh token error. resp: ${respStr}, code: ${errCode}`);
    }

    // 是否为重试，打印日志不同
    if (!once) {
      throw new Error(`rootStore.createSession error. try again. resp: ${respStr}, code: ${errCode}`);
    }
    throw new Error(`rootStore.createSession error. resp: ${respStr}, code: ${errCode}`);
  } catch (error) {
    Log.getInstance().logErr(`rootStore.createSession ${JSON.stringify(error)}`);
    // 失败重试请求一次
    if (!once) {
      const data = await createSession(true);
      return data;
    }
    return {};
  }
}

/**
 * 绑定微信票据
 */
export async function bindWXAccount(once = false, session = {}, wxInfo = {}) {
  try {
    const { appId, openId, accessToken } = wxInfo;

    const params = {
      appid: 'qb',
      auth_info: JSON.stringify({
        sa: String(session.sa),
        sk: String(session.sk),
        ...getWelfareCenterParams(),
      }),
      bind_account_auth_info: {
        type: 1,
        wechat_auth_info: {
          appid: String(appId),
          openid: String(openId),
          access_token: String(accessToken),
        },
      },
    };

    const resp = await $http.post(`${kdILiveHost}/cgi-bin/qb_live/coupon_account_svr_http/bind_account`, {
      data: params,
    });

    const respStr = JSON.stringify(resp);
    const { ret_code: retCode } = resp;

    // 成功
    if (retCode === SUCCESS) {
      return true;
    }

    // 是否为重试，打印日志不同
    if (!once) {
      throw new Error(`rootStore.bindWXAccount error. try again. resp: ${respStr}, code: ${retCode}`);
    }
    throw new Error(`rootStore.bindWXAccount error. resp: ${respStr}, code: ${retCode}`);
  } catch (error) {
    Log.getInstance().logErr(`rootStore.bindWXAccount ${JSON.stringify(error)}`);
    // 失败重试请求一次
    if (!once) {
      const data = await bindWXAccount(true, session, wxInfo);
      return data;
    }
    return false;
  }
}

/**
 * 获取是否已绑定微信票据
 */
export async function checkBindWXAccount() {
  try {
    const welfareUserInfo = getWelfareCenterParams();

    const params = {
      appid: 'qb',
      account_id: welfareUserInfo.qbid,
    };

    const resp = await $http.post(
      `${kdILiveHost}/cgi-bin/qb_live/coupon_account_svr_http/get_account_info`,
      {
        data: params,
      },
    );

    const respStr = JSON.stringify(resp);
    const { ret_code: retCode, bind_accounts: bindAccount = {} } = resp;

    // 成功
    if (retCode === SUCCESS) {
      const { account_info: accountInfo } = bindAccount;
      if (accountInfo && accountInfo.length > 0) {
        return true;
      }
      return false;
    }

    throw new Error(`rootStore.getBindAccount error. resp: ${respStr}, code: ${retCode}`);
  } catch (error) {
    Log.getInstance().logErr(`rootStore.getBindAccount ${JSON.stringify(error)}`);
    return false;
  }
}

/**
   * 获取优惠券中台授权
   */
export async function getCouponAuth() {
  try {
    const auth = await checkBindWXAccount();
    if (auth) {
      return USuccess;
    }

    const [session, wxInfo] = await Promise.all([createSession(true), wxAuth()]);

    // 获取浏览器登陆的sk，sa失败
    if (!session || !session.sk || !session.sa) {
      return UError;
    }

    // 获取微信授权失败
    if (!wxInfo) {
      return UWxAuthError;
    }

    // 取消微信授权
    if (wxInfo.authStatus === 1) {
      return UWXAuthCancel;
    }

    // 获取微信授权失败
    if (wxInfo.authStatus !== 0) {
      return UWxAuthError;
    }

    const result = await bindWXAccount(false, session, wxInfo);

    // 绑定失败
    if (!result) {
      throw new Error('rootStore.getCouponAuth createSession error.');
    }

    return USuccess;
  } catch (error) {
    Log.getInstance().logInfo(`rootStore.getCouponAuth ${JSON.stringify(error)}`);
    return UError;
  }
}

/**
 * 获取单品券使用链接
 */
export async function getViewerGoods(shopGoodsId, shopAppid) {
  try {
    const welfareUserInfo = getWelfareCenterParams();
    const extJson = {
      scene_id: 'welfare',
      channel_id: '3160',
      source: '100031',
      guid: welfareUserInfo.guid,
      account_type: welfareUserInfo.type,
      skip_id: `${welfareUserInfo.guid}_${new Date().getTime()}`,
    };

    const params = {
      shop_goods_id: shopGoodsId,
      appid: shopAppid,
      ext: JSON.stringify(extJson),
      program_id: '1234',
    };

    const resp = await $http.post(
      `${tencentLiveHost}/trpc.tlive.kdec_jumpurl_svr.QBHTTPSvr/GetViewerGoods`,
      {
        data: params,
        withCredentials: true,
      },
    );

    const respStr = JSON.stringify(resp);

    const { code: retCode, qb_mini_jump_url: qbMiniJumpUrl = '' } = resp;

    // 成功
    if (retCode === SUCCESS && qbMiniJumpUrl) {
      return qbMiniJumpUrl;
    }

    throw new Error(`rootStore.getViewerGoods error. resp: ${respStr}, code: ${retCode}`);
  } catch (error) {
    Log.getInstance().logInfo(`rootStore.getViewerGoods ${JSON.stringify(error)}`);
    return '';
  }
}
